import { render } from "./RouteIndex.vue?vue&type=template&id=64ed1622&scoped=true&ts=true"
import script from "./RouteIndex.vue?vue&type=script&lang=ts"
export * from "./RouteIndex.vue?vue&type=script&lang=ts"

import "./RouteIndex.vue?vue&type=style&index=0&id=64ed1622&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ed1622"]])

export default __exports__